<template>
  <el-dialog
    width="40%"
    class="dialog"
    :title="pageType === 'add' ? '创建回收人员' : '编辑回收人员'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="100px"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="formData.name"
          :maxLength="20"
          placeholder="请输入姓名"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证" prop="idNumber">
        <el-input
          v-model="formData.idNumber"
          :maxLength="18"
          placeholder="请输入身份证"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="formData.phone"
          :maxLength="11"
          placeholder="请输入手机号"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属组织" prop="organization">
        <BelongOrgSelect
          style="width: 100%"
          v-model="formData.organization"
          @change="handleOrgChange"
        ></BelongOrgSelect>
      </el-form-item>
      <el-form-item label="回收区域" prop="districtCode">
        <el-row :gutter="0">
          <el-col :span="8">
            <el-select
              v-model="formData.provinceCode"
              placeholder="请选择省份"
              clearable
              @change="getTblCity"
              @clear="formData.cityCode = formData.districtCode = null"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="formData.cityCode"
              placeholder="请选择市"
              clearable
              :disabled="!formData.provinceCode"
              @change="getTblDistrict"
            >
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                style="width: 100%"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="formData.districtCode"
              placeholder="请选择区域"
              clearable
              :disabled="!formData.cityCode"
              @change="changeDistrict"
            >
              <el-option
                v-for="item in districtList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                style="width: 100%"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="承接品类" prop="spidList">
        <el-select
          v-model="formData.spidList"
          multiple
          placeholder="请选择承接品类"
          @change="updateAttachmentsRequired"
        >
          <el-option
            v-for="item in acceptedCategoriesList"
            :key="item.spid"
            :label="item.spmc"
            :value="item.spid"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="合作种类：" prop="cooperationTypes">
        <el-checkbox-group v-model="formData.cooperationTypes">
          <el-checkbox label="1">普通回收</el-checkbox>
          <el-checkbox label="2">以旧换新-支线物流</el-checkbox>
          <el-checkbox label="3">批量回收</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->
      <el-form-item label="上传高空作业证" prop="highWorkPermit">
        <div style="display: flex;">
          <image-upload
            :imageUrl.sync="attachments1"
            :editMode="true"
            @success="uploadSuccess($event, 'attachments1')"
            @delete="deleteUpload('attachments1')"
            :appendToBody="true"
            :showDel="true"
          />
          <image-upload
            v-if="attachments1"
            :imageUrl.sync="attachments2"
            :editMode="true"
            @success="uploadSuccess($event, 'attachments2')"
            @delete="deleteUpload('attachments2')"
            :appendToBody="true"
            :showDel="true"
          />
        </div>
      </el-form-item>
      <el-form-item
        v-if="orgCooperationType && orgCooperationType.includes('1')"
        label="上传保险凭证"
        prop="insuranceImage"
      >
        <div style="display: flex;">
          <image-upload
            :imageUrl.sync="insuranceImage1"
            :editMode="true"
            @success="uploadSuccess($event, 'insuranceImage1')"
            @delete="deleteUpload('insuranceImage1')"
            :appendToBody="true"
            :showDel="true"
          />
          <image-upload
            v-if="insuranceImage1"
            :imageUrl.sync="insuranceImage2"
            :editMode="true"
            @success="uploadSuccess($event, 'insuranceImage2')"
            @delete="deleteUpload('insuranceImage2')"
            :appendToBody="true"
            :showDel="true"
          />
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import BelongOrgSelect from "@/components/BelongOrgSelect";
import imageUpload from "@/components/Upload/ImageUpload";
// import { findAllProvince, findAllCity } from "@/api/COldForNew";
import {
  getProductType,
  findAllProvince,
  findAllCity,
  findAllDistrict,
  addEngineer
} from "@/api/masterFile";
export default {
  components: {
    BelongOrgSelect,
    imageUpload
  },
  data() {
    return {
      pageType: "add",
      dialogFormVisible: false,
      acceptedCategoriesList: [], //品类列表
      provinceList: [], //省份列表
      cityList: [], //市列表
      districtList: [], //区域列表
      attachments: [], //上传的附件列表
      attachments1: "",
      attachments2: "",
      insuranceImage1: "",
      insuranceImage2: "",
      orgCooperationType: "", // 当前选中组织的合作类型
      formData: {
        id: "",
        provinceCode: "",
        province: "",
        cityCode: "",
        city: "",
        districtCode: "",
        district: "",
        name: "",
        idNumber: "",
        phone: "",
        organization: "",
        spidList: [], // 承接品类
        highWorkPermit: "", // 上传附件(字符串逗号隔开)
        insuranceImage: "", // 保险凭证
        cooperationTypes: [] // 合作种类
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idNumber: [
          { required: true, message: "请输入身份证", trigger: "blur" },
          { pattern: /^[1-9]\d{16}[\dXx]$/, message: "请输入正确的身份证号" }
        ],
        phone: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号" }
        ],
        organization: [
          { required: true, message: "请选择所属组织", trigger: "blur" }
        ],

        provinceCode: [
          { required: true, message: "请选择省份", trigger: "change" }
        ],
        cityCode: [{ required: true, message: "请选择市", trigger: "change" }],
        districtCode: [
          { required: true, message: "请选择完整省市区", trigger: "change" }
        ],
        spidList: [
          { required: true, message: "请选择承接品类", trigger: "change" }
        ],
        highWorkPermit: [
          {
            required: false,
            trigger: "change", // 修改为非必选
            validator: this.validateHighWorkPermit,
            message: "请上传高空作业证"
          }
        ],
        insuranceImage: [
          {
            required: false,
            trigger: "change",
            validator: this.validateInsuranceImage,
            message: "请上传保险凭证"
          }
        ],
        // cooperationTypes: [
        //   { required: true, message: "请选择合作种类", trigger: "change" }
        // ]
      },
      btnLoading: false
    };
  },

  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    }
  },

  methods: {
    async validateHighWorkPermit(rule, value, callback) {
      if (
        !value &&
        this.formData &&
        this.formData.spidList &&
        this.formData.spidList.includes(101)
      ) {
        callback(new Error("请上传高空作业证"));
      } else {
        callback();
      }
    },
    async validateInsuranceImage(rule, value, callback) {
      if (
        !value &&
        this.orgCooperationType &&
        this.orgCooperationType.includes("1")
      ) {
        callback(new Error("请上传保险凭证"));
      } else {
        callback();
      }
    },
    async getProductTypeOption() {
      const res = await getProductType();
      if (res.statusCode === 200) {
        this.acceptedCategoriesList = res.data.filter(
          item => item.spid !== 105
        );
      }
    },
    closeDialog() {
      Object.assign(this.$data, this.$options.data());
      this.$refs.ruleForm.resetFields();

      this.dialogFormVisible = false;
    },
    updateAttachmentsRequired() {
      // 根据所选的承接品类更新附件的验证规则
      const hasAirConditioner = this.formData.spidList.includes(101);
      this.$refs.ruleForm.rules.highWorkPermit[0].required = hasAirConditioner;

      const needsInsurance = this.orgCooperationType && this.orgCooperationType.includes("1");
      this.$refs.ruleForm.rules.insuranceImage[0].required = needsInsurance;
    },
    // 处理组织切换
    handleOrgChange(org) {
      if (org) {
        this.orgCooperationType = org.cooperationType || "";
      } else {
        this.orgCooperationType = "";
      }
      this.updateAttachmentsRequired();
    },
    // 打开弹框
    async openDialog(pageType = "add", editData) {
      await this.getProductTypeOption();
      await this.getTblProvince();

      this.pageType = pageType;
      this.dialogFormVisible = true;

      Object.assign(this.$data.formData, this.$options.data().formData);
      this.attachments1 = this.attachments2 = null;
      this.insuranceImage1 = this.insuranceImage2 = null;
      this.orgCooperationType = "";

      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
      if (pageType === "edit") {
        this.editId = editData.id;
        this.setAttachments(editData.highWorkPermit, "highWorkPermit");
        this.setAttachments(editData.insuranceImage, "insuranceImage");
        await this.loadLocationData(editData);
        this.populateFormData(editData);
        // 如果是编辑，需要获取当前组织的合作类型
        this.getOrgCooperationType(editData.organization);
      }
    },
    // 获取组织的合作类型（用于编辑时初始化）
    getOrgCooperationType(partnershipId) {
      const url = "/autoapp-recovery-server-auth/api/tbl-partner-management/list";
      this.HttpService.post(url, {}).then(res => {
        if (res.statusCode === 200) {
          const org = res.data.find(item => item.partnershipId === partnershipId);
          if (org) {
            this.orgCooperationType = org.cooperationType || "";
            this.updateAttachmentsRequired();
          }
        }
      });
    },
    setAttachments(val, type) {
      if (val) {
        const attachments = val.split(",");
        if (type === "highWorkPermit") {
          this.attachments1 = attachments[0] || "";
          this.attachments2 = attachments[1] || "";
        } else if (type === "insuranceImage") {
          this.insuranceImage1 = attachments[0] || "";
          this.insuranceImage2 = attachments[1] || "";
        }
      }
    },

    async loadLocationData(editData) {
      if (editData.provinceCode) {
        await this.getTblCity(editData.provinceCode);
        if (editData.cityCode) {
          await this.getTblDistrict(editData.cityCode);
        }
      }
    },

    populateFormData(editData) {
      for (let item in this.formData) {
        this.formData[item] = editData[item];
      }
      if (editData.spids) {
        this.formData.spidList = editData.spids.split(",").map(Number);
      }
      this.updateAttachmentsRequired()
    },
    async submitBtnFun() {
      this.formData.highWorkPermit = this.getHighWorkPermit();
      this.formData.insuranceImage = this.getInsuranceImage();
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          const params = { ...this.formData };
          this.saveFormDataReq(params);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    getHighWorkPermit() {
      return this.attachments1 && this.attachments2
        ? `${this.attachments1},${this.attachments2}`
        : this.attachments1 || this.attachments2;
    },

    getInsuranceImage() {
      return this.insuranceImage1 && this.insuranceImage2
        ? `${this.insuranceImage1},${this.insuranceImage2}`
        : this.insuranceImage1 || this.insuranceImage2;
    },

    async saveFormDataReq(params) {
      console.log("save", this.formData);

      let res = await addEngineer(params);

      this.btnLoading = false;
      if (res.statusCode === 200) {
        const tipMsg = this.pageType === "add" ? "新增成功" : "修改成功";
        this.$message.success(tipMsg);
        this.$refs.ruleForm.resetFields();
        this.dialogFormVisible = false;
        this.$emit("opera-success");
      } else {
        this.$message.error(res.message);
      }
    },
    async uploadSuccess(val, flag) {
      this[flag] = val;
      // 清除高空作业证的提示
      if (flag === "attachments1" || flag === "attachments2") {
        this.$refs.ruleForm.clearValidate(["highWorkPermit"]);
      }
      // 清除保险凭证的提示
      if (flag === "insuranceImage1" || flag === "insuranceImage2") {
        this.$refs.ruleForm.clearValidate(["insuranceImage"]);
      }
    },
    async deleteUpload(flag) {
      if (flag == "attachments1" && this.attachments2) {
        this.attachments1 = this.attachments2;
        this.attachments2 = null;
      } else if (flag == "insuranceImage1" && this.insuranceImage2) {
        this.insuranceImage1 = this.insuranceImage2;
        this.insuranceImage2 = null;
      } else {
        this[flag] = null;
      }
    },
    //获取省份列表
    async getTblProvince() {
      this.formData.cityCode = "";
      this.formData.districtCode = "";

      let { statusCode, data } = await findAllProvince();
      if (statusCode === 200) {
        this.provinceList = data;
      }
    },
    //根据省份获取城市列表
    async getTblCity(code) {
      this.formData.cityCode = "";

      const paramsCode = this.formData.provinceCode || code;

      if (!paramsCode) {
        return;
      }
      const selectedProvince = this.provinceList.find(
        item => item.id === paramsCode
      );
      this.formData.province = selectedProvince ? selectedProvince.name : ""; // 赋值省份名称

      let { statusCode, data } = await findAllCity(paramsCode);
      if (statusCode === 200) {
        this.cityList = data;
      }
    },
    //根据省份获取城市列表
    async getTblDistrict(code) {
      this.formData.districtCode = "";
      const paramsCode = this.formData.cityCode || code;
      if (!paramsCode) {
        return;
      }

      const selectedCity = this.cityList.find(item => item.id === paramsCode);
      this.formData.city = selectedCity ? selectedCity.name : ""; // 赋值城市名称

      let { statusCode, data } = await findAllDistrict(paramsCode);
      if (statusCode === 200) {
        this.districtList = data;
      }
    },
    //获取区域的名称
    async changeDistrict() {
      const selectedDistrict = this.districtList.find(
        item => item.id === this.formData.districtCode
      );
      this.formData.district = selectedDistrict ? selectedDistrict.name : ""; // 赋值区域名称
    }
  }
};
</script>

<style scoped lang="scss">
.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/components/AddOrEditMasterDialog.vue